import { useMutation } from "@tanstack/react-query";
import { get } from "../../api/client";
import { getValue } from "../../utils/object.utils";

export interface CheckStudentExistsParams {
  studentFirstName: string;
  studentLastName: string;
  studentMiddleName?: string;
  branchId: number;
  classId: number;
}

export interface CheckStudentExistsResult {
  studentExists: boolean;
  studentId: number | null;
}

export const useCheckStudentExists = () =>
  useMutation(
    async ({
      studentMiddleName,
      ...params
    }: CheckStudentExistsParams): Promise<CheckStudentExistsResult> => {
      const response = await get({
        url: "api/v1/students/check-student-exist",
        params: {
          ...params,
          // Omitted entirely when blank so the (optional) backend param
          // isn't sent as an empty string.
          ...(studentMiddleName ? { studentMiddleName } : {}),
        },
      });

      return {
        studentExists: !!getValue(response, "data.studentExists"),
        studentId: getValue(response, "data.studentId"),
      };
    },
  );
